import { ArrayParam, NumberParam, NumericObjectParam, ObjectParam, StringParam } from 'use-query-params'

import { FILTERS_PARAMS_KEYS } from '@app/api/constants'

import { columnSearchSchemaOptionType } from '@app/hooks/useTableSearch/сonstants'

import { DAY_OF_WEEK_OPTIONS } from '@app/constants/week'

import { dateFormat } from '@app/constants'

import { LntRangeDatePickerProps } from '@app/components/base/Form/Input/DatePicker/Range/types'

import type { ColumnTableSearchSchema, TableSearchQuerySchema } from '@app/hooks/useTableSearch/types'
import type { MonitoringScheduleColumns, MonitoringScheduleColumnsSchedule } from './types'

export const columnTitleMap: Record<keyof MonitoringScheduleColumns, string> = {
  monitoringType: 'Тип мониторинга',
  monitoringSubtype: 'Подтип',
  store: 'ТК Ленты',
  cluster: 'Кластер',
  clustersGroup: 'Группа кластеров',
  salesOrganization: 'Сбытовая организация'
} as const

export const topFiltersQuerySchema = {
  [FILTERS_PARAMS_KEYS.monitoringTypeIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.monitoringSubtypeIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.storeIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.clusterIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.clustersGroupIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.salesOrganizationIds]: ArrayParam
} as const

export const tableSearchQuerySchema: TableSearchQuerySchema<
MonitoringScheduleColumns & MonitoringScheduleColumnsSchedule
> = {
  'table-store': StringParam,
  'table-cluster': StringParam,
  'table-clustersGroup': StringParam,
  'table-monitoringType': StringParam,
  'table-monitoringSubtype': StringParam,
  'table-salesOrganization': StringParam,
  'table-newDataDeadlineDays': NumberParam,
  'table-monitoringStartDayOfWeek': NumericObjectParam,
  'table-receivingDataDeadlineDays': NumberParam,
  'table-processingDataDeadlineDays': NumberParam,
  'table-newDataDeadlineTime': ObjectParam,
  'table-monitoringStartAtTime': ObjectParam,
  'table-receivingDataDeadlineTime': ObjectParam,
  'table-processingDataDeadlineTime': ObjectParam
} as const

const titleWrapperProps = { minWidth: 200 } as const
const commonRangeTimePickerProps: LntRangeDatePickerProps = {
  picker: 'time',
  format: dateFormat.HH_mm,
  placeholder: ['от', 'до']
}

export const columnsSearchSchema: ColumnTableSearchSchema<
MonitoringScheduleColumns & MonitoringScheduleColumnsSchedule
> = {
  store: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  cluster: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  clustersGroup: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  monitoringType: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  monitoringSubtype: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  salesOrganization: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  newDataDeadlineDays: { type: columnSearchSchemaOptionType.NUMERIC_INPUT, titleWrapperProps: { minWidth: 75 } },
  monitoringStartDayOfWeek: {
    type: columnSearchSchemaOptionType.NUMERIC_SELECT,
    titleWrapperProps: { minWidth: 100 },
    controlProps: { options: DAY_OF_WEEK_OPTIONS }
  },
  receivingDataDeadlineDays: { type: columnSearchSchemaOptionType.NUMERIC_INPUT, titleWrapperProps: { minWidth: 75 } },
  processingDataDeadlineDays: { type: columnSearchSchemaOptionType.NUMERIC_INPUT, titleWrapperProps: { minWidth: 75 } },
  newDataDeadlineTime: {
    type: columnSearchSchemaOptionType.DATE_RANGE,
    titleWrapperProps: { minWidth: 150 },
    controlProps: commonRangeTimePickerProps
  },
  monitoringStartAtTime: {
    type: columnSearchSchemaOptionType.DATE_RANGE,
    titleWrapperProps: { minWidth: 150 },
    controlProps: commonRangeTimePickerProps
  },
  receivingDataDeadlineTime: {
    type: columnSearchSchemaOptionType.DATE_RANGE,
    titleWrapperProps,
    controlProps: commonRangeTimePickerProps
  },
  processingDataDeadlineTime: {
    type: columnSearchSchemaOptionType.DATE_RANGE,
    titleWrapperProps: { minWidth: 150 },
    controlProps: commonRangeTimePickerProps
  }
}
